<template>
  <section class="token-index mt-3">
    <div class="row">
      <div class="col">
        <h1 class="mb-0">V2 Tokens</h1>
        <p class="mb-0">Solana Token 2022 List</p>
      </div>
      <div class="col-auto mt-2">
        <router-link class="btn btn-white" to="/app/tools/token_create"
          ><i class="fa fa-plus"></i> Create Token</router-link
        >
      </div>
    </div>

		<div class="card animate__animated animate__fadeIn">
			<div class="card-header">
				<div class="flex max-lg:flex-col gap-2">
					<div class="field-group">
						<input class="input" placeholder="Search tokens" v-model="sVal" @input="onSearch">
					</div>
          <div class="flex gap-2">
            <label class="field-group lg:max-w-fit">
              <span class="addon w-full">
                <input v-model="verifiedOnly" type="checkbox" class="checkbox mr-2">
                <span>Verified Tokens</span>
              </span>
            </label>
            <label class="field-group lg:max-w-fit">
              <span class="addon w-full">
                <input v-model="v2Only" type="checkbox" class="checkbox mr-2">
                v2 Only
              </span>
            </label>
          </div>
				</div>
			</div>
			<div class="card-body">
				<table class="table table-sm mt-4">
					<thead>
					<tr>
						<th class="w-25">Symbol</th>
						<th class="d-none d-lg-table-cell w-50">Name</th>
						<th>Address</th>
						<th class="d-none d-lg-table-cell">Metadata</th>
						<th>Version</th>
					</tr>
					</thead>
					<tbody>
					<tr class=" animate__animated animate__fadeIn [&_td]:!align-middle" @click="$router.push(`/${token.address}`)" v-for="token in filteredItems" :key="token.address">
						<td>
							<TokenImage :mint="token.address"></TokenImage>
						</td>
						<td class="d-none d-lg-table-cell">
							{{ token.name.replace(/\0/g, "") }}
						</td>
						<td>
							<AccountAddress :names="false" :address="token.address"></AccountAddress>
						</td>
						<td class="d-none d-lg-table-cell">
							<AccountAddress :address="token.metadata"></AccountAddress>
						</td>
						<td>
							{{ token.programID === 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA' ? 'v1' : 'v2' }}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="card-footer">
				<div>
					<button :disabled="page <= 0" class="btn btn-outline-light btn-sm" @click="prevPage">Prev</button>
					<button :disabled="searchTokens.length < limit" class="btn btn-outline-light btn-sm float-end" @click="nextPage">Next</button>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import AccountAddress from "@/components/common/AccountAddress.vue";
import TokenImage from "@/components/common/TokenImage.vue";
import {web3} from "@project-serum/anchor";

export default {
  name: "TokenIndex",
  components: { TokenImage, AccountAddress },
  data() {
    return {
      programTokens: [],
      fmt: Intl.NumberFormat(),
      verifiedOnly: true,
      v2Only: true,

      //
      searchTokens: [],
      searchTimeout: null,
      sVal: "",
      search: "",
      limit: 25,
      page: 0,
    };
  },
  watch: {
    verifiedOnly: function () {
      this.page = 0;
      this.tokenIndex();
    },
    v2Only: function () {
      this.page = 0;
      this.tokenIndex();
    },
  },
  computed: {
    filteredItems: function () {
      let items = this.searchTokens;

			if (this.verifiedOnly && !this.isPublicKey())
				items = items.filter(f => f.verified)

			if (this.v2Only && !this.isPublicKey()) {
				items = items.filter(f => f.programID !== 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
			}

			return items
		}
	},
	methods: {
		isPublicKey: function() {
			try {
				new web3.PublicKey(this.sVal)
				return true
			} catch (e) {
				return false
			}
		},
		onSearch: function () {
			this.debounce(() => {
				if (this.sVal.length >= 3) {
					this.doSearch()
				} else if(this.sVal.length === 0) {
					this.tokenIndex()
				} else {
					this.searchTokens = []
				}
			}, 400)
		},
		debounce: function (func, wait) {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => func(), wait);
		},

    doSearch: function () {
      console.log("Searching", this.sVal);
      this.$store.state.solana.fluxClient
        .searchToken(this.sVal, this.page)
        .then((r) => {
          this.searchTokens = r;
        });
    },

    tokenIndex: function () {
      this.$store.state.solana.fluxClient
        .getTokenIndex(this.verifiedOnly, this.v2Only, this.page, this.limit)
        .then((r) => {
          this.searchTokens = r;
        });
    },

    nextPage: function () {
      this.page++;

      if (this.sVal > 1) this.doSearch();
      else this.tokenIndex();
    },
    prevPage: function () {
      this.page--;
      if (this.page < 0) this.page = 0;

      if (this.sVal > 1) this.doSearch();
      else this.tokenIndex();
    },
  },
  beforeMount() {
    this.tokenIndex();
  },
};
</script>

<style scoped>
tbody tr {
  cursor: pointer;
}

tbody tr:hover {
  background: var(--bs-dark);
  cursor: pointer;
}
</style>
